<template>
  <div>
    <b-modal
      id="modal-help-digital-application"
      size="lg"
      centered
    >
      <template #modal-title>
        <div class="magenta-title">Hilfe zu Beilagen hochladen</div>
      </template>
      <div>
        <p class="mb-1">Sie haben zwei Möglichkeiten: Klicken Sie auf das Pluszeichen, dann öffnet sich der Explorer.
          Wählen Sie die Datei an und Klicken Sie auf Öffnen. Oder verwenden Sie Drag & Drop. Ziehen Sie dazu die Datei aus dem Ordner über das Feld.
          Halten Sie dazu die Datei mit einer Maustaste fest und lassen Sie sie über dem Feld los. Die Datei erscheint jetzt über dem Feld in der Liste.
          Sie können die Dateien löschen oder ergänzen. Zum Löschen klicken Sie aufs Kreuz rechts vom Dateinamen der Beilage.
          Laden Sie jetzt weitere Beilagen hoch oder ergänzen Sie die Liste später. Die Beilagen bleiben gespeichert, auch wenn Sie das Gesuch schliessen.
          Zum Einreichen drücken Sie den Button.
        </p>
      </div>
      <template v-slot:modal-footer="{ ok }">
        <b-button size="sm" variant="danger" @click="ok()">
          Alles klar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    methods: {
    }
  }
</script>

<style lang="scss">
#modal-help-digital-application {
  padding-left: 0 !important;

  .magenta-title {
    color: $magenta;
    font-weight: $font-weight-bold;
  }
}
</style>
